import {useMemo} from 'react';
import {UserTypeEnum} from 'src/api/ProactApiClient';
import type {BreadcrumbItem} from 'src/app/layout/BackBar';
import type {PersonnelIndexViewType} from 'src/shared/constants/ViewTypes';
import type {
  IRouteService,
  ViewModeType,
} from 'src/shared/services/RouterService/IRouteService';

export interface UsePersonnelBreadcrumbsProps {
  mode: ViewModeType;
  id?: number;
  userType: UserTypeEnum;
  vendorId?: number;
  router: IRouteService;
  itemName?: string;
  fromTab?: PersonnelIndexViewType;
}

export const usePersonnelBreadcrumbs = ({
  mode,
  id,
  userType,
  vendorId,
  router,
  itemName,
  fromTab,
}: UsePersonnelBreadcrumbsProps): BreadcrumbItem[] => {
  return useMemo(() => {
    const getParentLabel = () => {
      if (vendorId) return 'Vendor Personnel';
      if (fromTab === 'all') return 'All Users';
      if (fromTab === 'activity') return 'User Activity';
      return userType === UserTypeEnum.Employee ? 'Employees' : 'Contractors';
    };

    const fallbackTo = router.getGoBackRoute(String(id));
    const crumbs: BreadcrumbItem[] = [
      {label: getParentLabel(), to: fallbackTo},
    ];

    if (mode === 'create') {
      crumbs.push({label: 'New User'});
    } else if (mode === 'edit') {
      crumbs.push({
        label: itemName || 'User',
        to: router.getViewRoute(String(id)),
      });
      crumbs.push({label: 'Edit'});
    } else {
      crumbs.push({label: itemName || 'User'});
    }

    return crumbs;
  }, [mode, id, userType, vendorId, router, itemName, fromTab]);
};
